<template>
    <div class="view-body view-body--module">
      <div class="view-data view-data--module">
        <div class="view-data__header view-data__header--module">
          <h1>{{title}}</h1>
        </div>
        <div class="file-wrapper">
            <form @submit.prevent="onSubmit" class="file">
                <input type="file" name="file" ref="file" @change="handleFileUpload()">
                <p>{{text}}</p>
            </form>
            <div class="form-footer">
                <button class="button-normal button-normal--media" @click="$emit('cancel')">Anuluj</button>
                <button class="button-normal button-normal--media" @click="submitFile()">Dalej</button>
            </div>
        </div>
      </div>
  </div>

</template>

<script>
export default {

    name: 'fileUpload',
    data(){
        return{

            title: 'Import produktów do zlecenia',

            text: 'Wybierz lub upuść plik .xls',
            file: '',

        }
    },
    methods:{

        handleFileUpload(){

            this.file = this.$refs.file.files[0];
            this.text = this.$refs.file.files[0].name;

        },

        submitFile(){

            let formData = new FormData();
            formData.append('file', this.file, this.file.name);

            const token = localStorage.getItem('auth_token');

           this.$http.post('products/imports/xls', formData, {
                headers: {

                'Authorization': `Bearer ${token}`,
                'Content-Type': 'multipart/form-data'

                }})
            .then(response => {

                this.$emit('cancel');

            })
            .catch(error => {

                console.error(error);

            })

        },

    },

}
</script>

<style lang="scss" scoped>

.view-body--module{
  position: absolute;
  background:#fff;
  width:100%;
  height:100%;
  left:0;
}

.file-wrapper{
    width:40%;
}

.file{
    display:flex;
    position:relative;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    border: 4px dashed rgb(214, 214, 214);
    height:200px;
    transition-duration: 0.2s;
    background:none;

    &:hover{
        opacity:0.5;
        transition-duration: 0.2s;
        background:rgb(235, 235, 235);
    }
}

.file p{
  width: 100%;
  text-align: center;
}

.file input{
  position: absolute;
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  outline: none;
  opacity: 0;
}

</style>
